import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Carousel from '../components/Home/Carousel';
import ProductCardContainer from '../components/Home/ProductCardsContainer';
import InfoContainer from '../components/Home/InfoContainer';
import { fetchFrontPageProducts } from '../flux/actions/product-actions';
import { ProductsReducerState } from '../flux/reducers/product-reducer';

import '../styles/App.scss';


const Home: FC = () => {

  const dispatch = useDispatch();

  const productReducer: ProductsReducerState = useSelector((state: any) => state.productReducer);
  const { frontPageProducts, loading } = productReducer;
  const mostPurchasedTitle = frontPageProducts?.displayMostPurchasedTitle ? 'Los más comprados' : 'También te podría interesar';

  useEffect(() => {
    dispatch(fetchFrontPageProducts());
  }, [dispatch]);

  return (
    <div>
      <Carousel />
      <ProductCardContainer
        loading = {loading} 
        products={frontPageProducts?.mostPurchasedProducts} 
        title={mostPurchasedTitle}
      />
      <InfoContainer />
      <ProductCardContainer 
        loading = {loading}
        products={frontPageProducts?.latestProducts}
        title="Nuestros últimos productos"
      />
    </div>
  );
}

export default Home;
